import React, { useEffect, useState, useContext } from "react";
import RecurringPaymentsService from "../../../../../services/api/recurring-payments.service";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import Utilities from "../../../../../services/commonservice/utilities";
import Table2 from "../../../../templates/components/Table2";
import DatePicker from "../../../../templates/components/DatePicker";
import { store } from "../../../../../context/StateProvider";
import RecurringPlanButtonGroup from "../../../../../services/commonservice/recurring-button-group.utility";

const PaymentPlanTable = (props) => {
  // context state and dispatch 
  const globalStateAndDispatch = useContext(store)
  const state = globalStateAndDispatch.state
  const [paymentPlanList, setPaymentPlanList] = useState();
  const [isLoader, setIsLoader] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [initialMessage, setInitialMessage] = useState(true)
  const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [locationList, setLocationList] = useState(state.practiceLocations || null)
  const findLocations = () => {
    AppointmentService.practiceLocationLookup()
        .then((res) => {
            setLocationList(res)
            setLocationId(res[0].practiceLocationId)

        })
        .catch((err) => {
            console.log(err);
        });
}
useEffect(() => {
  if (!locationList) {
      if (StorageService.get("session", "locale")) {
          let payload = JSON.parse(StorageService.get("session", "locale"))
          setLocationList(payload)
      }
      else {
          findLocations();
      }
  }
}, [])

  const paymentPlanLookup = () => {
      setIsLoader(true)
      let reqObj = {
      SortField: "CreatedOn",
      Asc: false,
    };
    if (locationId) {
      reqObj.PracticeLocationId = locationId
    }
    if (startDate) reqObj.StartDate = moment(startDate).toISOString()
    if (endDate) reqObj.EndDate = moment(endDate).toISOString()

    setInitialMessage(false);
    RecurringPaymentsService.findRecurringPayments(reqObj)
      .then((res) => {
        if (res?.data?.data) {
          setPaymentPlanList(res?.data?.data);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setIsLoader(false)
      });
  };

  const columns = [
  {
    Header: "Type",
    accessor: (tc) => tc.recurringType
  },
  {
    Header: "Invoice Number",
    accessor: (tc) => tc.invoiceNumber,
    minWidth: "150px"
  },
  {
    id: "status",
    Header: "Status",
    accessor: (pp) => pp.recurringStatus, 
    minWidth: "150px"
  },
  {
    Header: "First Name",
    accessor: (tc) => tc.firstName,
    minWidth: "150px"
  },
  {
    Header: "Last Name",
    accessor: (tc) => tc.lastName,
    minWidth: "150px"
  },

  {
    id: "nextTransactionDate",
    Header: "Next Date",
    accessor: (pp) => { 
      return pp.nextTransactionDate ? moment.utc(pp.nextTransactionDate).format("M/D/YYYY") : 'none'
    },
    minWidth: "150px"
  },
  {
    id: "nextTransactionAmount",
    Header: "Next Amount",
    accessor: (pp) => { return Utilities.toDollar(pp.nextTransactionAmount) },
    Footer: () => "Totals",
    minWidth: "150px"
  },

  {
    id: "TotalTxnAmount",
    Header: "Total Amount",
    meta: { sum: true, currency: true, numeric: true },
    accessor: (pp) => { return Utilities.toDollar(pp.fullAmountDue) },
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.fullAmountDue + sum, 0),
        [info.rows]
      )

      return <>{Utilities.toDollar(total)}</>
    },
    minWidth: "150px"
  },
  {
    id: "TotalTxnCount",
    Header: "Total Count",
    meta: { sum: true, numeric: true },
    accessor: (pp) => pp.noOfPayments,
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.noOfPayments + sum, 0),
        [info.rows]
      )

      return <>{total}</>
    },
    minWidth: "150px"
  },

  {
    id: "PaidTxnAmount",
    Header: "Paid Amount",
    meta: { sum: true, currency: true, numeric: true },
    accessor: (pp) => { return Utilities.toDollar(pp.paidTxnAmount) },
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.paidTxnAmount + sum, 0),
        [info.rows]
      )

      return <>{Utilities.toDollar(total)}</>
    },
    minWidth: "150px"
  },
  {
    id: "PaidTxnCnt",
    Header: "Paid Cnt",
    meta: { sum: true, numeric: true },
    accessor: (pp) => pp.paidTxnCnt,
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.paidTxnCnt + sum, 0),
        [info.rows]
      )

      return <>{total}</>
    },
    minWidth: "150px"
  },

  {
    id: "problemTxnAmount",
    Header: "Problem Amount",
    meta: { sum: true, currency: true, numeric: true },
    accessor: (pp) => { return Utilities.toDollar(pp.problemTxnAmount) },
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.problemTxnAmount + sum, 0),
        [info.rows]
      )

      return <>{Utilities.toDollar(total)}</>
    },
    minWidth: "150px"
  },
  {
    id: "problemTxnCnt",
    Header: "Problem Cnt",
    meta: { sum: true, numeric: true },
    accessor: (pp) => pp.problemTxnCnt,
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.problemTxnCnt + sum, 0),
        [info.rows]
      )

      return <>{total}</>
    },
    minWidth: "150px"
  },

  {
    id: "PendingTxnAmount",
    Header: "Pending Amount",
    meta: { sum: true, currency: true, numeric: true },
    accessor: (pp) => { return Utilities.toDollar(pp.pendingTxnAmount) },
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.pendingTxnAmount + sum, 0),
        [info.rows]
      )

      return <>{Utilities.toDollar(total)}</>
    },
    minWidth: "150px"
  },
  {
    id: "PendingTxnCount",
    Header: "Pending Count",
    meta: { sum: true, numeric: true },
    accessor: (pp) => pp.pendingTxnCount,
    Footer: info => {
      const total = React.useMemo(
        () =>
          info.rows.reduce((sum, row) => row.original.pendingTxnCount + sum, 0),
        [info.rows]
      )

      return <>{total}</>
    },
    minWidth: "150px"
  },
    {
      Header: "Actions",
      disableSortBy: true,
      excludeFromExport: true, //to exclude from export
      accessor: (pp) => {
        return <span className="row justify-content-end">
          <div className="col-auto btn-group">
            <RecurringPlanButtonGroup
              buttonClass={'p-0 ps-1'}
              initialData={pp}
              //extraButton={extraButtons}
              showStatusDescription={false}
              refresh={handleRefresh}
            ></RecurringPlanButtonGroup>
          </div>
        </span>
      }
    },
  ]
  const handleRefresh = () => {
    setPaymentPlanList();
    paymentPlanLookup();
  }
  return (
    <>
    <div className="row d-flex g-3">
      <div className="col-12 m-p-0">
        <Module title="Filters">
          <div className='row d-flex'>
            <div className='col-12 mx-0  report-filters'>
              <div className="d-flex row justify-content-center align-items-end">
                <DatePicker locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} includeAll />
                <div className="col-md-auto col-12"><button className="btn btn-primary" onClick={e => { e.preventDefault();setPaymentPlanList(); paymentPlanLookup() }} title="Pull Report"><i className="icon arrow circle right" /></button></div>
              </div>
            </div>
          </div>
        </Module>
      </div>
      <div className="col-12 m-p-0">
        <Module title="Payment Plan Report">
          <Table2 export searchable title="Payment Plan Report" data={paymentPlanList} loading={isLoader} columns={columns} initialMessage={initialMessage}/>
        </Module>
      </div>
    </div>
    </>
  );
};

export default PaymentPlanTable;
